/* Keeps the cart drawer + cart counters correct after "Add" buttons that talk to
   /cart/add.js directly (home page cards, "Customers also purchased", etc.).
   Independent of any festival theme: if the festival theme is on, it already does this
   (with its animation) and this file steps aside. */
(function () {
  if (window.__nvCartSync) return;
  window.__nvCartSync = true;

  var nc = window.festivalConfig;
  var festivalHandles = !!(nc && nc.cartAnimation !== false);

  var origFetch = window.fetch.bind(window);
  var root = function () { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); };

  /* header / bottom-bar cart counters (works with the custom header too) */
  function updateCounts(cart) {
    if (!cart) return;
    var n = cart.item_count;
    document.querySelectorAll('[data-cart-count], [data-cart-badge], .cart-count-bubble > span[aria-hidden]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', n < 1);
    });
    document.querySelectorAll('[class*="cart-count"]:not(.cart-count-bubble)').forEach(function (el) {
      if (el.children.length === 0) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; }
    });
    document.querySelectorAll('a[href$="/cart"][class*="ai-header-icon-link"]').forEach(function (a) {
      if (a.querySelector('[class*="cart-count"]')) return;
      var m = a.className.match(/ai-header-icon-link-([a-z0-9]+)/);
      if (!m) return;
      var s = document.createElement('span');
      s.className = 'ai-header-cart-count-' + m[1];
      s.textContent = n;
      a.appendChild(s);
    });
  }
  window.nvUpdateCounts = updateCounts;

  function refreshCounts() {
    return origFetch(root() + 'cart.js?_=' + Date.now(), { cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(updateCounts).catch(function () {});
  }
  window.nvRefreshCart = function () {
    var drawer = document.querySelector('cart-drawer');
    refreshCounts();
    if (drawer && drawer.renderContents) return drawer.renderContents(); // fetches fresh sections, then opens
  };

  if (festivalHandles) return;

  var inflight = 0, timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function wait() {
      if (inflight > 0) { timer = setTimeout(wait, 150); return; }
      window.nvRefreshCart();
    }, 200);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return origFetch(input, init);
    inflight++;
    var p = origFetch(input, init);
    p.then(function (res) {
      inflight = Math.max(0, inflight - 1);
      if (!res.ok) return;
      res.clone().json().then(function (data) {
        if (data && data.sections) return; // the product page form renders the drawer itself
        schedule();
      }).catch(function () {});
    }, function () { inflight = Math.max(0, inflight - 1); });
    return p;
  };
})();
